<template>
    <div>
        <CCard>
            <CCardBody>                

                <div class="info">
                    <table class="custom-table mb-4" v-if="tableInfo">
                        <tr>
                            <td colspan="4">
                                {{ i18n('QDFM.QDFMNo') }}：
                                {{ tableInfo.qdfmNo }}
                            </td>
                        </tr>
                        <tr>
                            <td class="info-header text-center" colspan="4">
                                <span v-if="tableInfo.formType === 1">lesson learn (QDFM-Film&Tape{{i18n('QDFM.Category')}})</span>
                                <span v-if="tableInfo.formType === 2">lesson learn (QDFM-LB)</span>
                                <span v-if="tableInfo.formType === 3">lesson learn (QDFM-{{i18n('QDFM.OrganizationBuilding')}})</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.SystemComparisonResults')}}</td>
                            <td colspan="3">{{ tableInfo.lessonLearn }}</td>
                        </tr>
                        <tr>
                            <td class="info-header text-center" colspan="4">{{i18n('QDFM.BasicInformation')}}</td>
                        </tr>
                        <tr>
                            <td width="35%">{{i18n('QDFM.MachineName')}}</td>
                            <td width="20%">{{ tableInfo.machineNo }}</td>
                            <td width="25%">{{i18n('QDFM.PartNumber')}}</td>
                            <td width="20%">
                                <el-input v-model="tableInfo.materialNo" v-if="isEdit"></el-input>
                                <span v-else>{{ tableInfo.materialNo }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.ROEPartNumber')}}</td>
                            <td colspan="3">{{ tableInfo.materialNoCust }}</td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.DesignDRI')}}</td>
                            <td>
                                <el-input v-model="tableInfo.driDesign" v-if="isEdit"></el-input>
                                <span v-else>{{ tableInfo.driDesign }}</span>
                            </td>
                            <td>{{i18n('QDFM.DevelopmentReviewSupervisor')}}</td>
                            <td>
                                <el-input v-model="tableInfo.designSupervisor" v-if="isEdit"></el-input>
                                <span v-else>{{ tableInfo.designSupervisor }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.ProductSize')}}</td>
                            <td>
                                <el-input v-model="tableInfo.productSize" v-if="isEdit"></el-input>
                                <span v-else>{{ tableInfo.productSize }}</span>
                            </td>
                            <td>{{i18n('QDFM.Material')}}</td>
                            <td>
                                <el-input v-model="tableInfo.material" v-if="isEdit"></el-input>
                                <span v-else>{{ tableInfo.material }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.ManufacturingMethod')}}</td>
                            <td colspan="3">
                                <el-input v-model="tableInfo.formMethod" v-if="isEdit"></el-input>
                                <span v-else>{{ tableInfo.formMethod }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{i18n('QDFM.NumberOfTooling')}}
                                <span class="hint">({{ i18n('QDFM.InputNumber') }})</span>
                            </td>
                            <td>
                                <el-input-number v-model="tableInfo.moldQty" :controls="false" :max="2147483647" v-if="isEdit"></el-input-number>
                                <span v-else>{{ tableInfo.moldQty }}</span>
                            </td>
                            <td>{{i18n('QDFM.TheMaterialOfTheTooling')}}</td>
                            <td>
                                <el-input v-model="tableInfo.moldMaterial" v-if="isEdit"></el-input>
                                <span v-else>{{ tableInfo.moldMaterial }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{i18n('QDFM.NumberOfToolingCavities')}}
                                <span class="hint">({{ i18n('QDFM.InputNumber') }})</span>
                            </td>
                            <td>
                                <el-input-number v-model="tableInfo.moldCavityQty" :controls="false" :max="2147483647" v-if="isEdit"></el-input-number>
                                <span v-else>{{ tableInfo.moldCavityQty }}</span>
                            </td>
                            <td>
                                {{i18n('QDFM.ToolingLife')}}
                                <span class="hint">({{ i18n('QDFM.InputNumber') }})</span>
                            </td>
                            <td>
                                <el-input-number v-model="tableInfo.moldLifeQty" :controls="false" :max="999999999.999" v-if="isEdit"></el-input-number>
                                <span v-else>{{ tableInfo.moldLifeQty }}</span>
                            </td>
                        </tr>

                        <tr>
                            <td class="info-header text-center" colspan="4">{{i18n('QDFM.ProblemAssessment')}}</td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.CanAllSpecificationsBeMet')}}</td>
                            <td>
                                <el-select v-model="tableInfo.isTolerance" :placeholder="i18n('QDFM.Select')" v-if="isEdit">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.Label"
                                        :label="item.Label"
                                        :value="item.Value"
                                    >
                                    </el-option>
                                </el-select>
                                <span v-else>{{ tableInfo.isTolerance === null ? null : (tableInfo.isTolerance ? 'Y' : 'N') }}</span>
                            </td>
                            <td colspan="2">
                                <el-input v-model="tableInfo.isToleranceInfo" v-if="isEdit" :placeholder="i18n('QDFM.Illustrate')+'：'" :title="tableInfo.isToleranceInfo"></el-input>
                                <span :title="tableInfo.isToleranceInfo" v-else>{{i18n('QDFM.Illustrate')}}：{{ tableInfo.isToleranceInfo }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.CriticalDimensionCPKGreaterThan')}}</td>
                            <td>
                                <el-select v-model="tableInfo.isCPK" :placeholder="i18n('QDFM.Select')" v-if="isEdit">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.Label"
                                        :label="item.Label"
                                        :value="item.Value"
                                    >
                                    </el-option>
                                </el-select>
                                <span v-else>{{ tableInfo.isCPK === null ? null : (tableInfo.isCPK ? 'Y' : 'N') }}</span>
                            </td>
                            <td colspan="2">
                                <el-input v-model="tableInfo.isCPKInfo" v-if="isEdit" :placeholder="i18n('QDFM.Illustrate')+'：'" :title="tableInfo.isCPKInfo"></el-input>
                                <span :title="tableInfo.isCPKInfo" v-else>{{i18n('QDFM.Illustrate')}}：{{ tableInfo.isCPKInfo }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.NecessaryToEstablishALimitedSample')}}</td>
                            <td>
                                <el-select v-model="tableInfo.isExteriorLimit" :placeholder="i18n('QDFM.Select')" v-if="isEdit">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.Label"
                                        :label="item.Label"
                                        :value="item.Value"
                                    >
                                    </el-option>
                                </el-select>
                                <span v-else>{{ tableInfo.isExteriorLimit === null ? null : (tableInfo.isExteriorLimit ? 'Y' : 'N') }}</span>
                            </td>
                            <td colspan="2">
                                <el-input v-model="tableInfo.isExteriorLimitInfo" v-if="isEdit" :placeholder="i18n('QDFM.Illustrate')+'：'" :title="tableInfo.isExteriorLimitInfo"></el-input>
                                <span :title="tableInfo.isExteriorLimitInfo" v-else>{{i18n('QDFM.Illustrate')}}：{{ tableInfo.isExteriorLimitInfo }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.OtherProblems')}}</td>
                            <td>
                                <el-select v-model="tableInfo.isOtherIssue" :placeholder="i18n('QDFM.Select')" v-if="isEdit">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.Label"
                                        :label="item.Label"
                                        :value="item.Value"
                                    >
                                    </el-option>
                                </el-select>
                                <span v-else>{{ tableInfo.isOtherIssue === null ? null : (tableInfo.isOtherIssue ? 'Y' : 'N') }}</span>
                            </td>
                            <td>{{i18n('QDFM.ProblemDescription')}}</td>
                            <td>
                                <el-input v-model="tableInfo.isOtherIssueInfo" v-if="isEdit" :placeholder="i18n('QDFM.Illustrate')+'：'" :title="tableInfo.isOtherIssueInfo"></el-input>
                                <span :title="tableInfo.isOtherIssueInfo" v-else>{{ tableInfo.isOtherIssueInfo }}</span>
                            </td>
                        </tr>

                        <tr>
                            <td class="info-header text-center" colspan="4">{{i18n('QDFM.PackageDesign')}}</td>
                        </tr>
                        <tr>
                            <td>
                                <span v-if="tableInfo.formType === 1">{{i18n('QDFM.PackagingMaterial')}}</span>
                                <span v-if="tableInfo.formType === 2">{{i18n('QDFM.PackingMethod')}}</span>
                                <span v-if="tableInfo.formType === 3">{{i18n('QDFM.WrapWithTray')}}</span>
                            </td>
                            <td>
                                <span v-if="tableInfo.formType === 1">
                                    <el-input v-model="tableInfo.packMaterial" v-if="isEdit" :title="tableInfo.packMaterial"></el-input>
                                    <span v-else>{{ tableInfo.packMaterial }}</span>
                                </span>
                                <span v-if="tableInfo.formType === 2">
                                    <el-input v-model="tableInfo.packMethod" v-if="isEdit" :title="tableInfo.packMethod"></el-input>
                                    <span v-else>{{ tableInfo.packMethod }}</span>
                                </span>
                                <span v-if="tableInfo.formType === 3">
                                    <el-select v-model="tableInfo.isTray" :placeholder="i18n('QDFM.Select')" v-if="isEdit">
                                        <el-option
                                            v-for="item in options"
                                            :key="item.Label"
                                            :label="item.Label"
                                            :value="item.Value"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{ tableInfo.isTray === null ? null : (tableInfo.isTray ? 'Y' : 'N') }}</span>
                                </span>
                            </td>
                            <td>
                                <span v-if="tableInfo.formType === 1">
                                    {{i18n('QDFM.APackOfSeveral')}}
                                    <span class="hint">({{ i18n('QDFM.InputNumber') }})</span>
                                </span>
                                <span v-if="tableInfo.formType === 2">{{i18n('QDFM.DifferentiateBINCodePackaging')}}</span>
                                <span v-if="tableInfo.formType === 3">
                                    {{i18n('QDFM.HowManyProductsAreThereInATray')}}
                                    <span class="text-danger">{{i18n('QDFM.IsY')}}</span>
                                    <span class="hint">({{ i18n('QDFM.InputNumber') }})</span>
                                </span>
                            </td>
                            <td>
                                <span v-if="tableInfo.formType === 1">
                                    <el-input-number v-model="tableInfo.packPiece" :controls="false" :max="2147483647" v-if="isEdit"></el-input-number>
                                    <span v-else>{{ tableInfo.packPiece }}</span>
                                </span>
                                <span v-if="tableInfo.formType === 2">
                                    <el-select v-model="tableInfo.isPackBIN" :placeholder="i18n('QDFM.Select')" v-if="isEdit">
                                        <el-option
                                            v-for="item in options"
                                            :key="item.Label"
                                            :label="item.Label"
                                            :value="item.Value"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{ tableInfo.isPackBIN === null ? null : (tableInfo.isPackBIN ? 'Y' : 'N') }}</span>
                                </span>
                                <span v-if="tableInfo.formType === 3">
                                    <el-input-number v-model="tableInfo.trayQty" :controls="false" :max="2147483647" v-if="isEdit"></el-input-number>
                                    <span v-else>{{ tableInfo.trayQty }}</span>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.BoxSize')}}</td>
                            <td>
                                <el-input v-model="tableInfo.boxSize" v-if="isEdit" :title="tableInfo.boxSize"></el-input>
                                <span v-else>{{ tableInfo.boxSize }}</span>
                            </td>
                            <td>
                                {{i18n('QDFM.FullBoxWeight')}}
                                <span class="hint">({{ i18n('QDFM.InputNumber') }})</span>
                            </td>
                            <td>
                                <el-input-number v-model="tableInfo.fullBoxWeight" :controls="false" :max="99999.99" v-if="isEdit"></el-input-number>
                                <span v-else>{{ tableInfo.fullBoxWeight }}</span>
                            </td>
                        </tr>

                        <tr>
                            <td class="info-header text-center" colspan="4">PFMEA</td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.SupplierUploadFile')}}</td>
                            <td colspan="3">
                                <ul class="uploded-file-list">
                                    <li
                                        v-for="(file, index) in pfmeaFiles"
                                        :key="file.guid"
                                    >
                                        <div class="link" @click="downloadFile(file)">
                                            <i class="el-icon-paperclip"></i>
                                            {{ file.fileName }}
                                            <span style="opacity: 0.5; margin-left: 10px">{{ (file.fileBytes / 1024 / 1024).toFixed(2) }}mb</span>
                                        </div>
                                        <el-button
                                            class="delete-btn"
                                            type="danger"
                                            icon="el-icon-delete"
                                            circle
                                            :disabled="!isEdit || isWatch"
                                            v-if="isEdit"
                                            @click.prevent="removeFile(index, file, true)"
                                        >
                                        </el-button>
                                    </li>
                                </ul>

                                <el-upload
                                    ref="upload"
                                    accept=".gif,.png,.jpg,.doc,.xls,.ppt,.docx,.xlsx,.pptx,.pdf"
                                    action
                                    multiple
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    :file-list="pfmeaFiles"
                                    :on-change="(file, fileList) => { changeUpload(file, fileList, true) }"
                                    v-if="isEdit"
                                >
                                    <el-button size="small" type="primary">{{i18n('QDFM.AddFile')}}</el-button>
                                </el-upload>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.SpecialInstructions')}}</td>
                            <td colspan="3">
                                <el-input v-model="tableInfo.pfmeaInfo" v-if="isEdit" :title="tableInfo.pfmeaInfo"></el-input>
                                <span v-else>{{ tableInfo.pfmeaInfo }}</span>
                            </td>
                        </tr>

                        <tr>
                            <td class="info-header text-center" colspan="4">{{i18n('QDFM.EquipmentAndToolingList')}}</td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.SupplierUploadFile')}}</td>
                            <td colspan="3">
                                <ul class="uploded-file-list">
                                    <li
                                        v-for="(file, index) in equipmentFiles"
                                        :key="file.guid"
                                    >
                                        <div class="link" @click="downloadFile(file)">
                                            <i class="el-icon-paperclip"></i>
                                            {{ file.fileName }}
                                            <span style="opacity: 0.5; margin-left: 10px">{{ (file.fileBytes / 1024 / 1024).toFixed(2) }}mb</span>
                                        </div>
                                        <el-button
                                            class="delete-btn"
                                            type="danger"
                                            icon="el-icon-delete"
                                            circle
                                            :disabled="!isEdit || isWatch"
                                            v-if="isEdit"
                                            @click.prevent="removeFile(index, file, false)"
                                        >
                                        </el-button>
                                    </li>
                                </ul>

                                <el-upload
                                    ref="upload"
                                    accept=".gif,.png,.jpg,.doc,.xls,.ppt,.docx,.xlsx,.pptx,.pdf"
                                    action
                                    multiple
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    :file-list="equipmentFiles"
                                    :on-change="(file, fileList) => { changeUpload(file, fileList, false) }"
                                    v-if="isEdit"
                                >
                                    <el-button size="small" type="primary">{{i18n('QDFM.AddFile')}}</el-button>
                                </el-upload>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.SpecialInstructions')}}</td>
                            <td colspan="3">
                                <el-input v-model="tableInfo.equipmentInfo" v-if="isEdit" :title="tableInfo.equipmentInfo"></el-input>
                                <span v-else>{{ tableInfo.equipmentInfo }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>{{i18n('QDFM.AssessmentScore')}}</td>
                            <td>{{ tableInfo.qdfmScore }}</td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.ExplanationImprovementOfUnreachedAssessmentScores')}}</td>
                            <td colspan="3">
                                <el-input v-model="tableInfo.unqualifyComment" v-if="isEdit" :title="tableInfo.unqualifyComment"></el-input>
                                <span v-else>{{ tableInfo.unqualifyComment }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{i18n('QDFM.ImprovementDescription')}}</td>
                            <td colspan="3">
                                <el-input v-model="tableInfo.improvement" v-if="isEdit" :title="tableInfo.improvement"></el-input>
                                <span v-else>{{ tableInfo.improvement }}</span>
                            </td>
                        </tr>
                        <tr  v-if="!isEdit">
                            <td>{{i18n('QDFM.AssessmentInstructions')}}</td>
                            <td colspan="3">
                                <el-input v-model="tableInfo.reviewInfo" v-if="!isWatch" :title="tableInfo.reviewInfo"></el-input>
                                <span v-else>{{ tableInfo.reviewInfo }}</span>
                            </td>
                        </tr>

                    </table>

                    <table class="custom-table" v-if="tableInfo">
                        <tr>
                            <td width="150px">{{i18n('QDFM.Time')}}</td>
                            <td width="100px">{{i18n('QDFM.State')}}</td>
                            <td>{{i18n('QDFM.AuditDescription')}}</td>
                            <td width="180px">{{i18n('QDFM.UpdateUser')}}</td>
                        </tr>

                        <tr v-for="log in tableInfo.qdfmFormLogs" :key="log.guid">
                            <td>{{ fixDate(log.logDate) }}</td>
                            <td>
                                <span v-if="log.reviewId === 3">{{i18n('QDFM.Manufacturer')}}</span>
                                <span v-if="log.reviewId === 5">{{i18n('QDFM.Quality')}}</span>
                                <span v-if="log.reviewId === 7">{{i18n('QDFM.Reject')}}</span>
                                <span v-if="log.reviewId === 9">{{i18n('QDFM.Close')}}</span>
                            </td>
                            <td>{{ log.reviewInfo }}</td>
                            <td>{{ log.createUser }}</td>
                        </tr>
                    </table>

                    <div class="send-wrap" v-if="tableInfo">
                        <div>
                            <el-button size="small" round v-if="isEdit" @click.prevent="memberReply">{{i18n('QDFM.Submit')}}</el-button>
                            <el-button size="small" round :disabled="tableInfo.reviewId !== 5" v-if="!isEdit && !isWatch" @click.prevent="employeeReply(9)">{{i18n('QDFM.Close')}}</el-button>
                            <el-button size="small" round :disabled="tableInfo.reviewId !== 5" v-if="!isEdit && !isWatch" @click.prevent="employeeReply(7)">{{i18n('QDFM.Reject')}}</el-button>
                            <el-button size="small" round @click.prevent="goBackEvent">{{i18n('QDFM.Return')}}</el-button>
                        </div>
                    </div>
                </div>
            </CCardBody>
        </CCard>


    </div>
</template>
<script>
import { Notification } from "element-ui";
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'

export default {
    mixins: [qualityMixin],	
    data() {
        return {
            defaultHeaders : [
                this.i18n("TrialProduction.PartNumber"),this.i18n("TrialProduction.Parts"),this.i18n("TrialProduction.Vendor"),this.i18n("TrialProduction.ProjectEstimatedTime")
            ],
            headers :[],
            otherItemHeaders :[],
            trialRow : {
            },
            planDtlList : [],
            t0NewPartList :[],
            isOneVendor : false,
            checkAll : false,
            batchUpdateParam: {},
            batchItemMemoModalTitle: '',
            batchItemMemoTxt : '',

            options: [  //  下拉項目
                {
                    Label: 'Y',
                    Value: true,
                },
                {
                    Label: 'N',
                    Value: false,
                },
            ],
            isEdit: false,  //  是否回覆(審核不需輸入)
            isWatch: false, //  是否觀看
            tableInfo: null,

            pfmeaFiles: [],         //  存放 "PFMEA" 全部檔案 (依序 舊排到新，協助畫面顯示)
            equipmentFiles: [],     //  存放 "生產設備&治具清單" 全部檔案 (依序 舊排到新，協助畫面顯示)

        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.defaultHeaders = [
                this.i18n("TrialProduction.PartNumber"),this.i18n("TrialProduction.Parts"),this.i18n("TrialProduction.Vendor"),this.i18n("TrialProduction.ProjectEstimatedTime")
            ]

            const trialKeys = sessionStorage.getItem('trialKeys');
            this.getDetail(trialKeys);
        },
        tableInfo: {    //  動態計算總分
            handler() {
                const vm = this;

                //  協助判斷是否從外層點擊觀看(只有點擊觀看query 才有值)
                let isNotWatch = Object.keys(vm.$route.query).length === 0 ? true : false;

                if(isNotWatch) {
                    if(vm.isMember) {   //  再次判斷狀態顯示方式
                        switch(vm.tableInfo.reviewId) {
                            case 3: {   //  廠商回覆中
                                vm.isEdit = true;
                                vm.isWatch = false;

                                break;
                            }

                            case 5: {   //  品質審核中
                                vm.isEdit = false;
                                vm.isWatch = true;
                                console.log('zzz')

                                break;
                            }

                            case 7: {   //  退件
                                vm.isEdit = true;
                                vm.isWatch = false;

                                break;
                            }

                            case 9: {   //  結案
                                vm.isEdit = true;
                                vm.isWatch = false;

                                break;
                            }
                                
                            default: {
                                vm.isEdit = true;
                                vm.isWatch = false;

                                break;
                            }
                        }
                    } else {
                        switch(vm.tableInfo.reviewId) {
                            case 3: {   //  廠商回覆中
                                vm.isEdit = false;
                                vm.isWatch = true;
                                
                                break;
                            }

                            case 5: {   //  品質審核中
                                vm.isEdit = false;
                                vm.isWatch = false;
                                
                                break;
                            }

                            case 7: {   //  退件
                                vm.isEdit = false;
                                vm.isWatch = true;

                                break;
                            }

                            case 9: {   //  結案
                                vm.isEdit = false;
                                vm.isWatch = true;

                                break;
                            }
                                
                            default: {
                                vm.isEdit = false;
                                vm.isWatch = true;

                                break;
                            }
                        }
                    }
                } else {
                    vm.isEdit = false;
                    vm.isWatch = true;
                }

                if(vm.isEdit) vm.calculateTotal();
            },
            deep:  true,
        },
    },
    methods: {
        getDetail (qdfmno){
            if(!qdfmno) return;            

            const vm = this;
            const url = `${this.$apiUrl_Quality}/GetQDFMForm/${qdfmno}`;

            this.updateLoading(true);            
            this.axios.get(url).then((response) => {
                const { errorMessage } = response.data;
                this.updateLoading(false);

                if(errorMessage){
                    Notification({
                        title: "失敗",
                        message: errorMessage,
                        type: "error",
                        duration: 5000,
                    });

                    vm.goBackEvent();
                }else{                    
                    //  --成功                 
                    vm.tableInfo = response.data;

                    let equipmentFileDetails = vm.tableInfo.equipmentFileDetails || []; //  判斷為 null 時轉換成 []
                    let pfmeaFileDetails = vm.tableInfo.pfmeaFileDetails || []; //  判斷為 null 時轉換成 []

                    vm.equipmentFiles = [     //  存放 "生產設備&治具清單" 全部檔案 (依序 舊排到新，協助畫面顯示)
                        ...equipmentFileDetails,
                    ];
                    vm.pfmeaFiles = [     //  存放 "PFMEA" 全部檔案 (依序 舊排到新，協助畫面顯示)
                        ...pfmeaFileDetails,
                    ];
 
                    
                }                    
            }); 
        },
        goBackEvent (){
            this.$router.push('qdfmform');
        },

        memberReply() {     //  廠商回覆 QDFM
            const vm = this;
            const url = `${this.$apiUrl_Quality}/CustomerUpdateQDFMForm`;

            if(vm.tableInfo.materialNo === null || vm.tableInfo.materialNo.length === 0) {
                Notification({
                    title: "失敗",
                    message: "您未輸入廠內料號，請再次輸入廠內料號",
                    type: "warning",
                    duration: 5000,
                });
                
                return;
            }

            if(vm.tableInfo.qdfmScore < 60 && (vm.tableInfo.unqualifyComment === null || vm.tableInfo.unqualifyComment.length === 0)) {    
                Notification({
                    title: "失敗",
                    message: "您評核分數未達60分，需填寫未達評核分數說明",
                    type: "warning",
                    duration: 5000,
                });

                return;
            }


            const formData = new FormData();
            let param = {
                qdfmNo: vm.tableInfo.qdfmNo,    //  QDFM單號
                MaterialNo: vm.tableInfo.materialNo,    //  廠內料號
                driDesign: vm.tableInfo.driDesign,  //  設計開發DRI
                designSupervisor: vm.tableInfo.designSupervisor,    //  開發審核主管
                productSize: vm.tableInfo.productSize,  //  產品SIZE長/寬/厚(最大外徑)
                material: vm.tableInfo.material,    //  材質
                formMethod: vm.tableInfo.formMethod,    //  成型方式
                moldQty: vm.tableInfo.moldQty || 0,     //  模具數
                moldMaterial: vm.tableInfo.moldMaterial,    //  模具材質
                moldCavityQty: vm.tableInfo.moldCavityQty || 0,     //  模具穴數
                moldLifeQty: vm.tableInfo.moldLifeQty || 0, //  模具壽命數
                isTolerance: vm.tableInfo.isTolerance,  //  規格公差無法全部滿足
                isToleranceInfo: vm.tableInfo.isToleranceInfo,  //  說明(規格公差無法全部滿足)
                isCPK: vm.tableInfo.isCPK,      //  重點尺寸無法全達到CPK1.33
                isCPKInfo: vm.tableInfo.isCPKInfo,  //  說明(重點尺寸無法全達到CPK1.33)
                isExteriorLimit: vm.tableInfo.isExteriorLimit,  //  外觀品味是否須建立限度
                isExteriorLimitInfo: vm.tableInfo.isExteriorLimitInfo,  //  說明(外觀品味是否須建立限度)
                isOtherIssue: vm.tableInfo.isOtherIssue,    //  其它問題
                isOtherIssueInfo: vm.tableInfo.isOtherIssueInfo,    //  說明(其它問題)
                packMaterial: vm.tableInfo.packMaterial,    //  包裝材質
                packPiece: vm.tableInfo.packPiece || 0,     //  一包片數
                packMethod: vm.tableInfo.packMethod,        //  包裝方式
                isPackBIN: vm.tableInfo.isPackBIN,          //  是否分BIN包裝
                isTray: vm.tableInfo.isTray,                //  包裝方式是否有Tray
                trayQty: vm.tableInfo.trayQty || 0,         //  一個Tray片數
                boxSize: vm.tableInfo.boxSize,              //  整箱SIZE(L/W/H)
                fullBoxWeight: vm.tableInfo.fullBoxWeight || 0,     //  滿箱重量(Kg)
                pfmeaFiles: vm.tableInfo.tempPfmeaFileDetails || [],  //  上傳檔案(PFMEA)
                deletePFMEAFiles: vm.tableInfo.deletePFMEAFiles || [],       //  舊檔案刪除資訊(PFMEA)
                pfmeaInfo: vm.tableInfo.pfmeaInfo,          //  特殊性說明(PFMEA)
                equipmentFiles: vm.tableInfo.tempEquipmentFileDetails || [],  //  上傳檔案(生產設備&治具清單)
                deleteEquipmentFiles: vm.tableInfo.deleteEquipmentFiles || [],   //  舊檔案刪除資訊(生產設備&治具清單)
                equipmentInfo: vm.tableInfo.equipmentInfo,  //  特殊性說明(生產設備&治具清單)
                qdfmScore: vm.tableInfo.qdfmScore || 0,     //  評核分數
                UnqualifyComment: vm.tableInfo.unqualifyComment,      //  未達評核分數說明
                Improvement: vm.tableInfo.improvement,                //  改善說明                 
            };


            Object.entries(param).forEach(item => {
                let [key, value] = item;
                if(value || typeof(value) === 'boolean') {     //  先確認是否為 null
                    if(Array.isArray(value)) {
                        if(key === 'deletePFMEAFiles' || key === 'deleteEquipmentFiles') {  //  刪除的陣列需另外處理
                            value.forEach((file, index) => {
                                formData.append(`${key}[${index}][guid]`, file.guid);
                                formData.append(`${key}[${index}][fileName]`, file.fileName);
                            });
                        } else {
                            value.forEach(file => formData.append(key, file.raw));
                        }
                    } else {
                        formData.append(key, value);
                    }
                }
            });

            // console.log(param, formData)


            this.updateLoading(true);            
            this.axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" }, }).then((response) => {
                const { errorMessage } = response.data;
                this.updateLoading(false);

                if(errorMessage){
                    Notification({
                        title: "失敗",
                        message: errorMessage,
                        type: "error",
                        duration: 5000,
                    });
                }else{                    
                    //  --成功                 
                    this.goBackEvent();
                }                    
            }); 
        },

        employeeReply(ReviewId) {   //  瑞儀品質人員簽核 QDFM
            const vm = this;
            const url = `${this.$apiUrl_Quality}/QualityUpdateQDFMForm`;

            let param = {
                QDFMNo: vm.tableInfo.qdfmNo,
                ReviewInfo: vm.tableInfo.reviewInfo,
                ReviewId,
            }

            if(ReviewId === 7 && !vm.tableInfo.reviewInfo) {    
                Notification({
                    title: "失敗",
                    message: "您需必填評核說明",
                    type: "warning",
                    duration: 5000,
                });

                return;
            }

            this.updateLoading(true);            
            this.axios.post(url, param).then((response) => {
                const { errorMessage } = response.data;
                this.updateLoading(false);

                if(errorMessage){
                    Notification({
                        title: "失敗",
                        message: errorMessage,
                        type: "error",
                        duration: 5000,
                    });
                }else{                    
                    //  --成功                 
                    this.goBackEvent();
                }                    
            }); 
        },

        changeUpload(file, fileList, isPFMEA) {     //  上傳檔案
            const vm = this;
            let oldTotal = 0;
            let newTotal = 0;

            if(isPFMEA) {   //  需先判斷是哪個區塊的上傳
                if(vm.tableInfo.pfmeaFileDetails) {     //  既有的檔案
                    vm.tableInfo.pfmeaFileDetails.forEach((item) => {
                        oldTotal += item.fileBytes;
                    });
                }

                if (vm.tableInfo.tempPfmeaFileDetails) {    //  新傳的檔案
                    vm.tableInfo.tempPfmeaFileDetails.forEach((item) => {
                        newTotal += item.size;
                    });
                }
            } else {
                if(vm.tableInfo.equipmentFileDetails) {     //  既有的檔案
                    vm.tableInfo.equipmentFileDetails.forEach((item) => {
                        oldTotal += item.fileBytes;
                    });
                }

                if (vm.tableInfo.tempEquipmentFileDetails) {    //  新傳的檔案
                    vm.tableInfo.tempEquipmentFileDetails.forEach((item) => {
                        newTotal += item.size;
                    });
                }
            }

            const isLt20M = (oldTotal + newTotal + file.size) / 1024 / 1024 < 20;
            
            if(!isLt20M) {
                vm.$message.error("檔案總大小不得超過 20MB!");
                return;
            } else {
                if(isPFMEA) {   //  需先判斷是哪個區塊的上傳
                    if(vm.tableInfo.tempPfmeaFileDetails) {
                        vm.tableInfo.tempPfmeaFileDetails.push({
                            ...file,
                            fileName: file.name,
                            fileBytes: file.size,
                        });
                    } else {
                        vm.tableInfo.tempPfmeaFileDetails = [];
                        vm.tableInfo.tempPfmeaFileDetails.push({
                            ...file,
                            fileName: file.name,
                            fileBytes: file.size,
                        });
                    }

                    let pfmeaFileDetails = vm.tableInfo.pfmeaFileDetails || []; //  判斷為 null 時轉換成 []
                    vm.pfmeaFiles = [     //  存放 "PFMEA" 全部檔案 (依序 舊排到新，協助畫面顯示)
                        ...pfmeaFileDetails,
                        ...vm.tableInfo.tempPfmeaFileDetails,
                    ];

                    
                } else {
                    if(vm.tableInfo.tempEquipmentFileDetails) {
                        vm.tableInfo.tempEquipmentFileDetails.push({
                            ...file,
                            fileName: file.name,
                            fileBytes: file.size,
                        });
                    } else {
                        vm.tableInfo.tempEquipmentFileDetails = [];
                        vm.tableInfo.tempEquipmentFileDetails.push({
                            ...file,
                            fileName: file.name,
                            fileBytes: file.size,
                        });
                    }

                    let equipmentFileDetails = vm.tableInfo.equipmentFileDetails || []; //  判斷為 null 時轉換成 []
                    vm.equipmentFiles = [     //  存放 "生產設備&治具清單" 全部檔案 (依序 舊排到新，協助畫面顯示)
                        ...equipmentFileDetails,
                        ...vm.tableInfo.tempEquipmentFileDetails,
                    ];
                }

                //  將計算的總分回寫
                //  "PFMEA" 的分數 供應商需上傳資料->得分 (10分)
                if(vm.pfmeaFiles.length > 0) vm.tableInfo.qdfmScore += 10;
                //  "生產設備&治具清單" 的分數 供應商需上傳資料->得分 (10分)
                if(vm.equipmentFiles.length > 0) vm.tableInfo.qdfmScore += 10;

            }

        },
        removeFile(index, file, isPFMEA) {
            const vm = this;
            
            if(isPFMEA) {
                if(file.guid) {
                    if(vm.tableInfo.deletePFMEAFiles) {
                        vm.tableInfo.deletePFMEAFiles.push({
                            guid: file.guid,
                            fileName: file.fileName,
                        });
                    } else {
                        vm.tableInfo.deletePFMEAFiles = [];
                        vm.tableInfo.deletePFMEAFiles.push({
                            guid: file.guid,
                            fileName: file.fileName,
                        });
                    }

                    //  刪除原始檔案
                    vm.tableInfo.pfmeaFileDetails.splice(
                        vm.tableInfo.pfmeaFileDetails.map(e => e.guid).indexOf(file.guid), 
                        1
                    );
                } else {
                    vm.tableInfo.tempPfmeaFileDetails.splice(
                        vm.tableInfo.tempPfmeaFileDetails.map(e => e.uid).indexOf(file.uid), 
                        1
                    );
                }

                vm.pfmeaFiles.splice(index, 1);
            } else {
                if(file.guid) {
                    if(vm.tableInfo.deleteEquipmentFiles) {
                        vm.tableInfo.deleteEquipmentFiles.push({
                            guid: file.guid,
                            fileName: file.fileName,
                        });
                    } else {
                        vm.tableInfo.deleteEquipmentFiles = [];
                        vm.tableInfo.deleteEquipmentFiles.push({
                            guid: file.guid,
                            fileName: file.fileName,
                        });
                    }

                    //  刪除原始檔案
                    vm.tableInfo.equipmentFileDetails.splice(
                        vm.tableInfo.equipmentFileDetails.map(e => e.guid).indexOf(file.guid), 
                        1
                    );
                } else {
                    vm.tableInfo.tempEquipmentFileDetails.splice(
                        vm.tableInfo.tempEquipmentFileDetails.map(e => e.uid).indexOf(file.uid), 
                        1
                    );
                }
    
                vm.equipmentFiles.splice(index, 1);
            }
            
            //  將計算的總分回寫
            //  "PFMEA" 的分數 供應商需上傳資料->得分 (10分)
            if(vm.pfmeaFiles.length === 0) vm.tableInfo.qdfmScore -= 10;
            //  "生產設備&治具清單" 的分數 供應商需上傳資料->得分 (10分)
            if(vm.equipmentFiles.length === 0) vm.tableInfo.qdfmScore -= 10;

        },
        downloadFile(file) {    //  檔案下載
            const vm = this;
            const api = `${this.$apiUrl_Quality}/QDFMGetFile/${file.guid}`;

            vm.axios.get(api, { responseType: "blob" }).then((response) => {
                let blob = new Blob([response.data]);
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement("a");

                link.href = url;
                link.download = file.fileName;
                link.click();

                window.URL.revokeObjectURL(url);
            });
        },
        calculateTotal() {  //  計算評核分數
            const vm = this;

            let total = 0;

            //  "tableInfo.lessonLearn" 的分數 (若為Null 得分，欄位有值為 0分)
            if(vm.tableInfo.lessonLearn === null || vm.tableInfo.lessonLearn.length === 0) total += 10;   //  系統比對回寫


            //  "基本資料" 的分數 (Y 為 0分)
            if(vm.tableInfo.machineNo) total += 1;   //  機種名稱
            if(vm.tableInfo.materialNo) total += 1;   //  廠內料號
            if(vm.tableInfo.materialNoCust) total += 1;   //  客戶料號
            if(vm.tableInfo.driDesign) total += 1;   //  設計開發DRI
            if(vm.tableInfo.designSupervisor) total += 1;   //  開發審核主管
            if(vm.tableInfo.productSize) total += 1;   //  產品SIZE長/寬/厚(最大外徑)
            if(vm.tableInfo.material) total += 1;   //  材質
            if(vm.tableInfo.formMethod) total += 1;   //  成型方式
            if(vm.tableInfo.moldQty) total += 1;   //  模具數
            if(vm.tableInfo.moldMaterial) total += 1;   //  模具材質
            if(vm.tableInfo.moldCavityQty) total += 4;   //  模具穴數
            if(vm.tableInfo.moldLifeQty) total += 1;   //  模具壽命數


            //  "可能問題點評估" 的分數 (四項中若有 Y 為 0分) 規格公差無法全部滿足、重點尺寸無法全達到CRK1.33、外觀品味是否須建立限度、其它問題
            if(vm.tableInfo.isTolerance === false && vm.tableInfo.isCPK === false && vm.tableInfo.isExteriorLimit === false && vm.tableInfo.isOtherIssue === false) total += 40;
        

            //  "包裝設計" 的分數 每格 1分（欄位有值得分，若為Null不計分）
            if(vm.tableInfo.packMaterial) total += 1;   //  包裝材質
            if(vm.tableInfo.packMethod) total += 1;   //  包裝方式
            if(vm.tableInfo.isTray) total += 1;   //  包裝方式是否有Tray

            if(vm.tableInfo.packPiece) total += 1;   //  一包幾片
            if(vm.tableInfo.isPackBIN) total += 1;   //  是否分BIN包裝
            if(vm.tableInfo.trayQty) total += 1;   //  一個Tray放幾片

            if(vm.tableInfo.boxSize) total += 1;   //  整箱SIZE

            if(vm.tableInfo.fullBoxWeight && vm.tableInfo.fullBoxWeight < 20) total += 12;   //  滿箱重量 一格 12分(值≧20kg以上為0分)


            //  "PFMEA" 的分數 供應商需上傳資料->得分 (10分)
            if(vm.pfmeaFiles.length > 0) total += 10;


            //  "生產設備&治具清單" 的分數 供應商需上傳資料->得分 (10分)
            if(vm.equipmentFiles.length > 0) total += 10;

            //  將計算的總分回寫
            vm.tableInfo.qdfmScore = total;
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"]),
    },
	mounted() {
        const QDFM_Key = sessionStorage.getItem('QDFM_Key');
        let Status = sessionStorage.getItem('QDFM_Status');

        if(QDFM_Key) this.getDetail(QDFM_Key);

        if(Status === 'reply') {    //  判斷是否 需顯示欄位輸入(承攬商回覆)
            this.isEdit = true;
        } else {
            this.isEdit = false;
        }

        if(Status === 'watch') {    //  判斷是否為 觀看
            this.isWatch = true;
        } else {
            this.isWatch = false;
        }

	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    // text-align: center;
    text-align: left;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}


.custom-table {
    width: 100%;
    margin-bottom: -1px;

    th, td {
        border: 2px solid #000;
        padding: 0.4rem;
    }

    .uploded-file-list {
        list-style: none;

        padding: 0;
        margin-bottom: 0;

        li {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:nth-child(odd) {
                background-color: #f5f5f5;
            }

            a, .link {
                color: #0e52c1;
                cursor: pointer;
            }
        }
        
        .delete-btn {
            background-color: transparent;
            color: #000;
            border: none;
            transition: all 0.2s;

            &:hover {
                background-color: #f56c6c;
                color: #fff;
            }
        }
    }

    ::v-deep .el-input-number .el-input__inner {
        text-align: left;
    }

    ::v-deep .el-input-number, ::v-deep .el-select {
        width: 100%;
    }
}

//下方按鈕
.send-wrap {
    text-align: center;
    position: sticky;
    margin-top: 20px;
    bottom: 20px;
    z-index: 5;

    & > div {
        background: linear-gradient(336deg, #70c5d2 35%, #2f75d1 100%);
        box-shadow: 3px -3px 5px rgba(0, 0, 0, 0.05);
        z-index: 3;
        border-radius: 25px;
        display: inline-block;
        padding: 8px;

        .el-button--default {
            border: 1px solid #fff;
            background-color: transparent;
            color: #fff;
        }
        .el-button--warning {
            border: 1px solid #fff;
            background-color: #fff;
            color: #000;
        }
    }
}

::v-deep .el-input__inner {
    border-width: 2px;
}

.hint {
    color: #f93154 !important;
    font-size: 12px;
}

</style>
